module.exports = __webpack_public_path__ + "img/rooms2.fae5ebee.jpg";